<template>
  <div class="m-search-page">
    <a-auto-complete
      v-model="form.search"
      :placeholder="$t('search.placeholder')"
      :filter-option="filterOption"
      @change="oncChangeSearch"
      optionLabelProp="value"
    >
      <template slot="dataSource">
        <a-select-option
          v-for="item in searchItems"
          :key="item.value"
          :value="item.value"
        >
          {{ item.label }}
        </a-select-option>
      </template>

      <a-input-search @search="onSearch"></a-input-search>
    </a-auto-complete>

    <a-list
      :data-source="list"
      :locale="{ emptyText: ' ' }"
    >
      <a-list-item slot="renderItem" slot-scope="item, index">
        <a class="m-link" v-if="item.type==='2'" :href="`${item.url}`" target="_blank">
          <i class="type-2-web"></i>
          <span class="m-list-number">{{ item.code }}</span>

          <span :num="index" class="m-list-text">
            {{ item.title }}
            <span
              class="m-clipboard"
              v-clipboard:copy="`${item.url}`"
              v-clipboard:success="copySuccess"
              v-clipboard:error="onError"
              @click.stop="doNothing"
              :title="`${$t('copy.link')}`"
            ></span>
          </span>
        </a>

        <a
          class="m-link"
          v-else
          :href="`https://support.sigma-rt.com.cn/tchelp/view?language=${currentLang}&productId=7&id=${item.id}`"
          target="_blank"
        >
          <i class="type-1-show" v-if="item.type==='1'"></i>
          <i class="type-3-goto" v-if="item.type==='3'"></i>
          <i class="type-4-script" v-if="item.type==='4'"></i>
          <i class="type-5-install" v-if="item.type==='5'"></i>
          <span class="m-list-number">{{ item.code }}</span>

          <span :num="index" class="m-list-text">
            {{ item.title }}
            <span
              class="m-clipboard"
              v-clipboard:copy="`https://support.sigma-rt.com/tchelp/view?language=${currentLang}&productId=7&id=${item.id}`"
              v-clipboard:success="copySuccess"
              v-clipboard:error="onError"
              @click.stop="doNothing"
              :title="`${$t('copy.link')}`"
            ></span>
          </span>
        </a>
      </a-list-item>

      <div slot="header" v-show="result">
        <template v-if="list.length !== 0">
          {{ $t('search.result', { search: this.form.search, number: list.length }) }}
        </template>
        <template v-else>
          {{ $t('no.search.results') }}&nbsp;<a href="mailto:support@sigma-rt.com">{{ $t('email.to.us') }}</a>
        </template>
      </div>
    </a-list>
  </div>
</template>

<script>
import { getHelpSearch } from '@/api/help'
import storage from 'store'

export default {
  name: 'SearchView',
  props: ['lang'],
  data () {
    return {
      list: [],
      searchItems: storage.get('search') ? storage.get('search') : [],
      form: {
        search: '',
        language: this.$store.getters.lang === 'en-US' ? 'en' : 'cn',
        productId: 7,
        version: ''
      },
      result: false,

      // 防抖用（可选但推荐）
      changeTimer: null
    }
  },
  computed: {
    currentLang () {
      const lang = this.$store.state.app.lang
      if (lang === 'en-US') return 'en'
      if (lang === 'zh-CN') return 'cn'
      return String(lang).split('-')[0]
    }
  },
  watch: {
    currentLang: {
      immediate: true,
      handler (val) {
        this.form.language = val
      }
    }
  },
  methods: {
    filterOption (input, option) {
      const text = (((option || {}).componentOptions || {}).children || [])[0]
      const label = (text && text.text) ? text.text : ''
      return label.toUpperCase().indexOf(String(input).toUpperCase()) >= 0
    },
    onError () {},
    copySuccess () {
      return this.$message.info(this.$t('copy.success'))
    },
    doNothing (event) {
      event.stopPropagation()
      event.preventDefault()
    },

    onSearch (value) {
      const q = (value ?? this.form.search ?? '')
      this.form.search = q
      clearTimeout(this.changeTimer)
      if (q !== '') {
        // 传快照，避免输入过程中对象被修改导致参数漂移
        this.getSearchTCHelpInfo({ ...this.form, search: encodeURIComponent(q) }, true, q, 'submit')
      } else {
        this.result = false
        this.list = []
      }
    },

    oncChangeSearch (value) {
      const q = (value ?? this.form.search ?? '')
      this.form.search = q

      // 可选：防抖，减少请求频率（A 取消也会工作，但防抖更省）
      clearTimeout(this.changeTimer)
      this.changeTimer = setTimeout(() => {
        const send = q.trim()
        if (send !== '') {
          this.getSearchTCHelpInfo({ ...this.form, search: encodeURIComponent(send) }, false, q, 'suggest')
        } else {
          this.result = false
          this.list = []
        }
      }, 250)
    },

    async getSearchTCHelpInfo (obj, flag, value, mode) {
      try {
        const { data: res } = await getHelpSearch(obj, { tcSearchMode: mode })
        this.list = res.data || []
        this.result = true

        // 仅在“搜索提交”（flag=true）且有结果时写入历史
        if (flag && this.list.length > 0) {
          const getSearchData = storage.get('search') ? storage.get('search') : []
          if (Array.isArray(getSearchData) && getSearchData.length >= 10) {
            getSearchData.shift()
          }

          if (Array.isArray(getSearchData)) {
            const objectExists = getSearchData.some(item => item.value === value)
            if (!objectExists) {
              getSearchData.push({ value: value, label: value })
              storage.set('search', getSearchData)
              this.searchItems = getSearchData
            }
          } else {
            storage.set('search', [])
          }
        }
      } catch (e) {
        // A 方案：被取消的请求直接忽略，避免闪空
        if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') return

        this.result = true
        this.list = []
      }
    }
  }
}
</script>

<style scoped lang="less">
.m-search-page {
  padding: 10px 20px;
}
.ant-input-search {
  // margin-bottom: 20px;
}
.ant-select {
  display: block;
}
.ant-list {
  text-align: left;
}

/deep/.ant-list-split {
  .ant-list-header {
    border-bottom: none;
  }
  .ant-list-item{
    &:first-child {
      border-top: 1px solid #e8e8e8;
    }

    &:hover {
      background-color: #f6fbff;
    }
  }
}

.m-list-number {
  display: inline-block;
  padding: 0 18px;
  color: #36b8f3;
}

.m-list-text {
  display: inline-block;
  font-size: 16px;
  color: #000000;
  position: relative;
  padding-right: 28px;
}
.ant-list-item {
  display: block;

  .m-clipboard {
    position: absolute;
    display: none;
    width: 24px;
    height: 16px;
    top: 4px;
    right: 0;
    background: url(~@/assets/img/copy-link.png) no-repeat center center;
    vertical-align: text-top;
    cursor: pointer;
    z-index: 1000;
  }

  &:hover {
    .m-clipboard {
      display: inline-block;
    }
  }

  .m-link {
    display: flex;
    flex-direction: row;
    flex-wrap: no-wrap;
    justify-content: flex-start;
  }
}
.m-list-item-left {
  width: 95px;
  display: inline-block;
}
.type-1-show,
.type-2-web,
.type-3-goto,
.type-4-script,
.type-5-install {
  display: inline-block;
  width: 16px;
  height: 16px;
  vertical-align: text-top;
  flex: 0 0 auto;
}

.type-1-show {
  background: url("~@/assets/img/help_show.png") no-repeat center center;
}

.type-2-web {
  background: url('~@/assets/img/help_web.png') no-repeat center center;
}

.type-3-goto {
  background: url('~@/assets/img/help_goto.png') no-repeat center center;
}

.type-4-script {
  background: url('~@/assets/img/help_script.png') no-repeat center center;
}
.type-5-install {
  background: url('~@/assets/img/help_download.png') no-repeat center center;
}
</style>
